// src/components/SharedUI.js
import React from 'react';
import { Flame, ShieldCheck, AlertTriangle, Info } from 'lucide-react';

export const RiskBadge = ({ score }) => {
  if (!score || isNaN(score)) return null;
  const b = parseFloat(score);
  
  if (b > 1.15) {
    return (
      <span className="flex items-center gap-1 text-red-500 bg-red-500/10 px-1.5 py-0.5 rounded text-[9px] font-black">
        <Flame size={12}/> High Risk (β {b.toFixed(2)})
      </span>
    );
  }
  
  if (b >= 0.85) {
    return (
      <span className="flex items-center gap-1 text-yellow-500 bg-yellow-500/10 px-1.5 py-0.5 rounded text-[9px] font-black">
        <AlertTriangle size={12}/> Med Risk (β {b.toFixed(2)})
      </span>
    );
  }
  
  return (
    <span className="flex items-center gap-1 text-emerald-500 bg-emerald-500/10 px-1.5 py-0.5 rounded text-[9px] font-black">
      <ShieldCheck size={12}/> Low Risk (β {b.toFixed(2)})
    </span>
  );
};

export const MetricRow = ({ label, val, themeClasses, tooltip }) => (
  <div className={`flex justify-between py-3 border-b ${themeClasses.border} text-[11px] font-bold group relative`}>
    <span className={`${themeClasses.textMuted} uppercase tracking-tight flex items-center gap-1 cursor-help`}>
      {label}
      {tooltip && <Info size={10} className="opacity-40 group-hover:opacity-100 transition-opacity text-indigo-500" />}
      
      {/* TOOLTIP POPUP */}
      {tooltip && (
        <div className={`absolute left-0 bottom-full mb-2 w-56 p-3 ${themeClasses.bgCard} border border-indigo-500/30 ${themeClasses.textMain} text-[10px] rounded-xl shadow-2xl z-50 normal-case tracking-normal opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity leading-relaxed`}>
          {tooltip}
        </div>
      )}
    </span>
    <span className={`font-mono ${themeClasses.textHead}`}>{val}</span>
  </div>
);